import { ActionTypes } from '../actions/app'
import { UploadConfig } from '../types'

export interface AppState {
  initialized: boolean
  upload: UploadConfig
  pasteOnly: boolean
  initRSW: boolean
  initFreshToken: boolean
}

export const uploadConfig: UploadConfig = {
  averageDuration: 104,
  extensions: ['.docx', '.gdocs', '.odt', '.rtf', '.txt'],
  filesize: {
    min: 0,
    max: 20971520,
  },
  mimeTypes: [
    'application/vnd.google-apps.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.oasis.opendocument.text',
    'text/rtf',
    'text/plain',
  ],
}

export const initialState: AppState = {
  initialized: false,
  upload: uploadConfig,
  // bypass googledocs configuration if `pasteOnly` === true
  pasteOnly: false,
  initRSW: true,
  initFreshToken: false,
}
export const app = (state = initialState, action: any) => {
  switch (action.type) {
    case ActionTypes.APP_INITIALIZING:
      return {
        ...state,
        initialized: false,
      }
    case ActionTypes.APP_INITIALIZED:
      return {
        ...state,
        initialized: true,
      }
    default:
      return state
  }
}
export default app
